document.addEventListener('DOMContentLoaded', () => {
    var toTopBtn = document.getElementById('scroll-to-top')
    var toTopAncre = document.getElementById('scroll-to-top-ancre')

    if (toTopBtn) {
        window.addEventListener('scroll', function (e) {
            var st = window.scrollY || document.documentElement.scrollTop;
            if (st > 100) {
                toTopBtn.classList.add("is-scrolled");
                toTopBtn.setAttribute("tabindex", "0");
            } else {
                toTopBtn.classList.remove("is-scrolled");
                toTopBtn.setAttribute("tabindex", "-1");
            }
        });

        toTopBtn.addEventListener('click', () => {
            window.scrollTo(0, 0);
            if (toTopAncre) {
                toTopAncre.focus()
            }
        })
    }
})